export const errFormatter = (err: any): any => {
  let status;
  let message;

  if (err.response) {
    status = err.response.status;
    message = err.response.data
      ? JSON.stringify(err.response.data)
      : "An error occurred";
  } else {
    message = err?.message || "An error occurred";
  }

  return { status, message };
};
